import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { withStyles } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import AuthService, { useAuthContext } from "../../../services/AuthService";
import { useNotificationContext } from "../../../services/NotificationService";
import { getSafePostLoginPath } from '../authRedirect';
import TermsConsent, { hasAcceptedTerms, rememberTermsAcceptance } from '../TermsConsent';
import styles from './styles';

const Login = (props) => {
    const { classes } = props;
    let navigate = useNavigate();

    console.log("================================== Login ======================================");

    // Get Auth Context
    const auth = useAuthContext();
    const notifications = useNotificationContext();

    // Component States
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [postLoginPath, setPostLoginPath] = useState(() => getSafePostLoginPath(window.location.search));
    const [termsAccepted, setTermsAccepted] = useState(hasAcceptedTerms);

    // Setup Component
    useEffect(() => {
        const googleAuth = AuthService.ConsumeGoogleCallback();
        if (googleAuth) {
            auth.dispatch({
                type: "LOGIN",
                payload: googleAuth,
            });
            setPostLoginPath(getSafePostLoginPath(window.location.search));
            setIsAuthenticated(true);
            return undefined;
        }

        const googleError = new URLSearchParams(window.location.search).get('google_error');
        if (googleError) {
            notifications.dispatch({
                type: "DISPLAY_ALERT",
                payload: { "message": "Google login could not be completed. Please try again.", "severity": "error" }
            });
        }

        if (isAuthenticated) {
            navigate(postLoginPath)
        }

        return () => {
            notifications.dispatch({
                type: "HIDE_ALERT"
            })
        }
    }, [isAuthenticated, postLoginPath]);

    const handleGoogleLoginClick = () => {
        if (!termsAccepted) {
            notifications.dispatch({
                type: "DISPLAY_ALERT",
                payload: { "message": "Please accept the Terms and Conditions before continuing.", "severity": "error" }
            });
            return;
        }
        rememberTermsAcceptance();
        AuthService.GoogleLogin({ returnTo: postLoginPath, termsAccepted: true });
    };

    return (
        <div className={classes.root}>
            <main className={classes.main}>
                <Container maxWidth="sm">
                    <Card>
                        <CardContent>
                            <Typography variant="h4" gutterBottom>
                                Welcome to PINN Hub
                            </Typography>
                            <TermsConsent checked={termsAccepted} onChange={(event) => setTermsAccepted(event.target.checked)} />
                            <div className={classes.buttonContainer}>
                                <Button variant="contained" color="primary" fullWidth onClick={handleGoogleLoginClick}>
                                    Continue with Google
                                </Button>
                            </div>
                        </CardContent>
                    </Card>
                </Container>
            </main>
        </div>
    );
};

export default withStyles(styles)(Login);
